module.exports = __webpack_public_path__ + "static/media/purchase.4f1b8441.png";